import "./Navbar.css";
import { Dropdown } from "./Dropdown.jsx";
import { useState } from "react";

export const Navbar = () => {

  const [toggle,setToggle] = useState(false);
  const [open,setOpen] =useState(1)

  const handleClick = ( ) => {

    setToggle(true)
    setOpen(open+1)
  }
 
 const handleClose = ( ) => {
   setToggle(false);
   setOpen(open + 1);
 };


  return (
    <>
      <div id="navbar-main-wrapper">
        <a href="/">
          {" "}
          <div id="navbar-vihari-logo-wrap">
            <img id="navbar-vihari-logo" src="./logo.png" alt="logo" />
          </div>
        </a>
        <div id="navbar-drop-down-hamburger-icon-wrap" onClick={handleClick}>
          <img src="./Menu.png" alt="" id="navbar-drop-down-hamburger-icon" />
        </div>
      </div>
      {toggle === true && open % 2 === 0 && (
        <Dropdown handleClose={handleClose} />
      )}

      <div id="navbar-desktop-main-wrapper">
        <a href="">
          <div>About Us</div>
        </a>
        <a href="">
          <div>Projects</div>
        </a>
        <a href="">
          <div id="desktop-view-logo-wrap">
            <img src="./desktop-logo.png" alt="logo" id="desktop-view-logo" />
          </div>
          <div id="desktop-view-logo-title">VIHARI PROJECTS</div>
        </a>
        <a href="">
          <div>Gallery</div>
        </a>
        <a href="">
          <div>Contact Us</div>
        </a>
      </div>
    </>
  );
};
